import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser'

export default class Light extends Phaser.GameObjects.Image
{
    /**
     * 
     * @param {Phaser.Scene} scene 
     * @param {number} x 
     * @param {number} y 
     * @param {string} color one of the LIGHT_COLORS constants (or null to use a random one)
     */
    constructor(scene, x, y, color)
    {
        if (color == null)
        {
            color = Phaser.Utils.Array.GetRandom(LIGHT_COLORS_ARRAY);
        }
        super(scene, x, y, ABCyaPhaser.Images.DEFAULT_ATLAS, 'sprites/' + color + '_light_off');

        this._on = 'sprites/' + color + '_light_on';
        this._off = this.frame.name;

        this._isOn = false;

        this.name = color;
    }

    get isOn()
    {
        return this._isOn;
    }

    toggle()
    {
        this._isOn = !this._isOn;
        this.setFrame(this._isOn ? this._on : this._off);
    }

    turnOn()
    {
        if (!this._isOn) this.toggle();
    }

    turnOff()
    {
        if (this._isOn) this.toggle();
    }
}

export const LIGHT_COLORS =
{
    red: "red",
    blue: "blue",
    green: "green",
    yellow: "yellow"
}

const LIGHT_COLORS_ARRAY = [LIGHT_COLORS.red, LIGHT_COLORS.blue, LIGHT_COLORS.yellow, LIGHT_COLORS.green];
Object.freeze(LIGHT_COLORS_ARRAY);
export { LIGHT_COLORS_ARRAY };